var _defs, _path, _path2, _circle, _circle2, _circle3, _circle4, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackMc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#182828;stroke-miterlimit:10;stroke-width:20px;}.cls-2{fill:#182828;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1040.75,540c0-106.11-29.65-169.34-45.45-195.52a29.4,29.4,0,0,0-25.2-14.13H109.4a29.4,29.4,0,0,0-25.2,14.13C68.4,370.66,38.75,433.89,38.75,540c0,99.59,30.06,166.43,45.79,194.57a29.46,29.46,0,0,0,25.75,15.08H969.21A29.46,29.46,0,0,0,995,734.57C1010.69,706.43,1040.75,639.59,1040.75,540Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.51,533.53v13.59a8.59,8.59,0,0,1-8.58,8.59H193.74a8.59,8.59,0,0,0-8.59,8.58v51.17a8.58,8.58,0,0,1-8.58,8.58H163a8.58,8.58,0,0,1-8.59-8.58V564.29a8.59,8.59,0,0,0-8.59-8.58H94.64a8.59,8.59,0,0,1-8.59-8.59V533.53a8.58,8.58,0,0,1,8.59-8.59h51.18a8.6,8.6,0,0,0,8.59-8.59V465.17a8.58,8.58,0,0,1,8.59-8.59h13.57a8.58,8.58,0,0,1,8.58,8.59v51.18a8.6,8.6,0,0,0,8.59,8.59h51.19A8.58,8.58,0,0,1,253.51,533.53Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 967.76,
    cy: 540.31,
    r: 25.69,
    transform: "translate(279.41 1409.03) rotate(-80.78)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 852.94,
    cy: 540.31,
    r: 25.69,
    transform: "translate(182.98 1295.69) rotate(-80.78)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 910.35,
    cy: 482.9,
    r: 25.69,
    transform: "translate(287.86 1304.15) rotate(-80.78)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 910.35,
    cy: 597.72,
    r: 25.69,
    transform: "translate(174.53 1400.57) rotate(-80.78)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 300.18,
    y: 389.28,
    width: 468.9,
    height: 301.44,
    rx: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M374.13,514.84v-73H417.9v14.59H388.72v14.59H417.9v14.59H388.72v29.18Zm43.77-58.36h14.6v14.59H417.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M476.27,500.25h29.18v14.59H461.68v-73h14.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M535,514.84V456.48h14.6v14.59h29.18V456.48h14.59v58.36H578.76V485.66H549.58v29.18Zm14.6-73v14.59h29.18V441.89Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M622.18,441.89h14.59v14.59H622.18Zm14.59,14.59h14.6v14.59h-14.6Zm14.6,58.36V471.07H666v43.77ZM666,456.48h14.59v14.59H666Zm14.59-14.59h14.59v14.59H680.55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.72,642.74V562H393.9v20.18h40.35V562h20.17v80.7H434.25V602.39H393.9v40.35ZM393.9,541.87V562h40.35V541.87Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M494.29,642.74V541.87h60.52V562H514.46v20.18h40.35v20.17H514.46v40.35Zm40.34-40.35h20.18v20.18H534.63ZM554.81,562H575v20.18H554.81Zm0,60.53H575v20.17H554.81Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M615.33,642.74V541.87h60.52V562H635.5v60.53h40.35v20.17ZM696,562v60.53H675.85V562Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackMc);
export default __webpack_public_path__ + "static/media/Black MC.cd028a87d8a6c5eec88da73695466e63.svg";
export { ForwardRef as ReactComponent };